import React from "react";
import { InfoBox } from "newui/components/IconBox";
import { useRatingWorkflow } from "../../../../context/RatingWorkflowContext";
import type { ReviewFrequency } from "newui/features/MySuppliers/types/supplier-performance.types";

export const SelectFrequencyStep: React.FC = () => {
	const { state, dispatch } = useRatingWorkflow();

	const handleFrequencyChange = (frequency: ReviewFrequency) => {
		dispatch({
			type: "SET_FREQUENCY",
			payload: { frequency },
		});
	};

	return (
		<div data-testid="select-frequency-step">
			<h3 className="mb-4 text-lg font-semibold text-gray-900">
				Review Frequency
			</h3>
			<p className="mb-4 text-sm text-gray-600">
				Choose whether this is a one-off review or part of a periodic
				series.
			</p>

			<div className="mb-6 flex gap-4">
				<label
					className={`flex flex-1 cursor-pointer items-center gap-3 rounded-lg border p-4 ${state.frequency === "one_off"
						? "border-blue-500 bg-blue-50"
						: "border-gray-200"
						}`}
					data-testid="frequency-one-off"
				>
					<input
						type="radio"
						name="frequency"
						value="one_off"
						checked={state.frequency === "one_off"}
						onChange={() => handleFrequencyChange("one_off")}
						className="h-4 w-4 text-blue-600"
					/>
					<div>
						<div className="text-sm font-medium text-gray-900">
							One-off Review
						</div>
						<div className="text-xs text-gray-500">
							A single performance assessment
						</div>
					</div>
				</label>

				<label
					className={`flex flex-1 cursor-pointer items-center gap-3 rounded-lg border p-4 ${state.frequency === "periodic"
						? "border-blue-500 bg-blue-50"
						: "border-gray-200"
						}`}
					data-testid="frequency-periodic"
				>
					<input
						type="radio"
						name="frequency"
						value="periodic"
						checked={state.frequency === "periodic"}
						onChange={() => handleFrequencyChange("periodic")}
						className="h-4 w-4 text-blue-600"
					/>
					<div>
						<div className="text-sm font-medium text-gray-900">
							Periodic Review
						</div>
						<div className="text-xs text-gray-500">
							Part of a recurring review series
						</div>
					</div>
				</label>
			</div>

			{state.frequency === "periodic" && (
				<InfoBox>
					Periodic reviews allow you to track performance changes over
					time. Each new review in the series will show the previous
					score for comparison, helping you identify trends and
					improvements.
				</InfoBox>
			)}
		</div>
	);
};
